// extracted by mini-css-extract-plugin
export default {"quickView":"product_quickView__gPryl","container":"product_container__yWTpN"};